import CarBreadcrumb from "../../commonComponents/breadcrumbs/CarBreadcrumb";
import CarDetail from "../../commonComponents/productDetail/CarDetail";

const CarLayout2Container = () => {
  return (
    <>
      <CarBreadcrumb mailClass="style-breadcrumbs-2" type="car_detail" multiple />
      <CarDetail type="car" />
    </>
  );
};

export default CarLayout2Container;
